import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import {
  FetchBaseQueryError,
  type FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react';

import type { ESBBaseError } from '@appTypes/esb/errors';
import { sentryRTKQueryReport } from '@modules/shared/utils/sentryReport';

export const rtkQuerySentryLogger: Middleware =
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (_api: MiddlewareAPI) => next => action => {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
    if (!isRejectedWithValue(action)) return next(action);

    const statusCode = action.payload.status;
    const payload = action.payload as FetchBaseQueryError;
    const actionError = action.error;
    const baseQueryMeta = action.meta?.baseQueryMeta as FetchBaseQueryMeta;

    const queryArg = action.meta?.arg?.originalArgs;
    const endpointName = action.meta?.arg?.endpointName as string;

    const request = baseQueryMeta?.request;
    const url = request?.url;
    const httpMethod = request?.method;

    const transactionName = `${httpMethod} ${endpointName}`;
    const esbErrorCode = (payload.data as ESBBaseError)?.errorCode;
    const webscriptResponseCode = (payload.data as { ResponseCode: string })
      ?.ResponseCode;

    const correlationId =
      baseQueryMeta?.response?.headers.get('x-correlation-id') || '';

    sentryRTKQueryReport({
      correlationId,
      httpMethod,
      request,
      extra: { queryArg, actionError, payload, url },
      esbErrorCode,
      transactionName,
      statusCode: webscriptResponseCode || statusCode,
      webscriptResponseCode,
      endpointName,
    });
    return next(action);
  };
